import React, { useMemo, useState, useEffect } from 'react';

import {
	TranslatedString,
	LocallySortedAndPaginatedTable,
	makeLocallySortedAndPaginatedTableColumnHeader,
	CommandBar,
	useAjax,
	XhrStatus,
	PrimaryButton,
	Card,
	Dropdown
} from '@bosch/bt-ui';

import './CompanyPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import SearchBox from '../../components/SearchBox';
import { useNavigate } from 'react-router-dom';
import RestfulCallout from '../../components/RestfulCallout';
import RestfulCallLoading from '../../components/RestfulCallLoading';

const TABLE_HEADERS = [
	makeLocallySortedAndPaginatedTableColumnHeader('name', 'Name'),
	makeLocallySortedAndPaginatedTableColumnHeader('customer-id', 'SAP Company ID'),
	makeLocallySortedAndPaginatedTableColumnHeader('sales-region', 'Sales Region'),
	makeLocallySortedAndPaginatedTableColumnHeader('update', 'Click to Edit')
];

function applySearchTextFilter(rows, searchText) {
	const lowercaseSearchText = searchText.toLowerCase().trim();

	if (lowercaseSearchText === '')
		return rows;

	return rows?.filter(task => {
		return task.columns.some(column => {
			return typeof (column.columnContent) === 'string' && column.columnContent?.toLowerCase().trim().includes(lowercaseSearchText);
		});
	});
}

function makeRow(task, navigate) {
	const {
		companyId,
		companyName,
		sapCompanyId,
		sapSalesRegion
	} = task;

	return {
		key: companyId,
		columns: [
			{
				key: 'name',
				columnContent: companyName
			},
			{
				key: 'customer-id',
				columnContent: sapCompanyId
			},
			{
				key: 'sales-region',
				columnContent: sapSalesRegion
			},
			{
				key: 'update',
				columnContent: <PrimaryButton>Update</PrimaryButton>
			}
		],
		htmlAttributes: {
			onClick: () => navigate('/company/update/' + encodeURIComponent(companyId))
		},
		subRows: []
	};
}

const CompanyPage = (props) => {
	const {
		token,
	} = props;

	const [searchText, setSearchText] = useState('');
	const [returnResult, status, getSimStatus, response] = useAjax(XhrStatus.InProgress);
	const navigate = useNavigate();
	const [currentPage, setCurrentPage] = useState(1);
	
	// This State will keep list of reservation company for dropdown
	const [reservation, setReservation] = useState([]);
	// This State will keep selected item of dropdown
	const [selected, setSelected] = useState('');
	const handleChange = event => {
		setSelected(event.value);
		console.log(event);
		var target = reservation.filter(l => l.value === event.value)
		console.log(target);
		if (target && target.length > 0)
			navigate('/company/add/' + encodeURIComponent(target[0].value) + '/' + encodeURIComponent(target[0].sapSalesRegion) + '/' + encodeURIComponent(target[0].label) + '/' + (target[0].deviceRegion == null ? '' : encodeURIComponent(target[0].deviceRegion)))
	};

	useEffect(
		() => {
			// If useAjax(XhrStatus.InProgress) and not login yet, it will show 401
			// So we need to make sure token is avaliable to continue...
			if (token?.token)
				getSimStatus('GET', SUPPORTCONSOLE_API_URL + '/api/companymanager/v1/companies', null, undefined, { 'Authorization': 'Bearer ' + token.token });
		},
		[token, getSimStatus]
	);

	const rows = useMemo(
		() => {
			console.log(returnResult);
			setCurrentPage(1);

			// Update reservation list
			(returnResult?.data) ? setReservation(returnResult.data.reservations) : [];

			(returnResult?.data) ? sessionStorage.setItem('deviceRegionOptions', JSON.stringify(returnResult.data.deviceRegionOptions)) : [];			
			
			// Setup default reservation for create new company and Sort by String property ASCENDING (A - Z)
			// setReservation(reservation => [...reservation, {label:'Create Company', value:'00000000', sapSalesRegion:'us'}].sort((a, b) => a.name > b.name ? 1 : -1));
			

			// Update company list
			const unfilteredRows = (returnResult?.data) ? returnResult.data.companyInfos.map(item => makeRow(item, navigate)) : [];
			return applySearchTextFilter(unfilteredRows, searchText);
		},
		[returnResult, searchText, navigate]
	);

	return (
		<Card
			htmlAttributes={{
				id: 'company-page'
			}}
		>
			<RestfulCallout status={status} response={response} returnObj={returnResult} hideSuccess={true} />
			<CommandBar
				search={
					<SearchBox
						fieldName="search"
						htmlAttributes={{
							onChange: update => setSearchText(update.value),
							value: searchText
						}}
					/>
				}
				actions={
					<div style={{ display: 'flex' }}>
						<span style={{ textAlign: 'center', alignSelf: 'center' }}>Search for existing company to update, or select pre-registration company to add a new one, press ----&gt;   </span>
						<div style={{ width: '500px' }}>
						<Dropdown
							fieldName="companyReservation"
							options={reservation}
							htmlAttributes={{
								onChange: handleChange,
								value: selected,
								required: true,
								menuIsOpen: true,
								placeholder: <TranslatedString stringId="Please select" />
							}}
						/>
						</div>
					</div>
				}
			/>
			{
				< LocallySortedAndPaginatedTable
					headers={TABLE_HEADERS}
					rows={rows}
					numRowsPerPage={50}
					currentPage={currentPage}
					goToPageFunc={setCurrentPage}
					htmlAttributes={{
						className: 'company-table'
					}}
					errorMessage="Error occured"
					noResultsMessage={<TranslatedString stringId="No items found" />}
					defaultSortColumn="name"
					defaultSortDirection="asc"
				/>
			}
			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(CompanyPage));